import { render, staticRenderFns } from "./RegionOverview.vue?vue&type=template&id=05121323&scoped=true"
import script from "./RegionOverview.vue?vue&type=script&lang=js"
export * from "./RegionOverview.vue?vue&type=script&lang=js"
import style0 from "./RegionOverview.vue?vue&type=style&index=0&id=05121323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05121323",
  null
  
)

export default component.exports